import { Component, OnInit } from '@angular/core';
import { SelectItem } from 'primeng/api';
import { DataView } from 'primeng/dataview';
import { LiveShopService } from 'src/app/services/liveshop.service';
import { Product } from 'src/app/api/product';
import { Asset } from 'src/app/models/liveshop';
import { ProductService } from 'src/app/servicesApollo/product.service';

@Component({
  selector: 'app-shorts',
  templateUrl: './shorts.component.html',
  styleUrls: ['./shorts.component.scss']
})
export class ShortsComponent implements OnInit {
  products: Product[] = [];
  assets: Asset[] = [];

  sortOptions: SelectItem[] = [];

  sortOrder: number = 0;

  sortField: string = '';

  sourceCities: any[] = [];

  targetCities: any[] = [];

  orderCities: any[] = [];

  rangeDates: Date[] | null = null;

  constructor(
    private productService: ProductService,
    private liveShopService: LiveShopService
  ) {

  }

  ngOnInit() {
    this.sendUidsToService([], 0);
    // this.liveShopService.getAssets().subscribe({
    //   next: (res) => {

    //     this.assets = res;
    //     console.log(res);
    //     this.filteredAssets = [...this.assets];


    //     // Calcula a somatória inicial dos durations
    //     let totalDurationSeconds = this.assets.reduce((acc, asset) => {
    //       const assetDuration = asset.items.reduce((accInner, item) => {
    //         return accInner + (item.media.duration || 0); // Adiciona duration, considerando 0 para null
    //       }, 0);
    //       return acc + assetDuration;
    //     }, 0);

    //     // Formata a somatória total de durations para o formato de horas e minutos
    //     //this.contentTime = this.formatDuration(totalDurationSeconds);

    //   },
    //   error: (err) => {

    //   }
    // });
  }

  onSortChange(event: any) {
    const value = event.value;

    if (value.indexOf('!') === 0) {
      this.sortOrder = -1;
      this.sortField = value.substring(1, value.length);
    } else {
      this.sortOrder = 1;
      this.sortField = value;
    }
  }

  onFilter(dv: DataView, event: Event) {
    dv.filter((event.target as HTMLInputElement).value);
  }

  loading: boolean = true;
  filterValue: string = ''; // Armazena o valor do filtro atual
  filteredAssets!: Asset[];
  selectedType: string | null = null;
  typeOptions = [
    { label: 'Todos', value: null },
    { label: 'Live', value: 'live' },
    { label: 'Shorts', value: 'shorts' }
  ];
  selectedStatus: string = 'todos';
  statusOptions = [
    { label: 'Todos', value: 'todos' },
    { label: 'Publicado', value: 'publicado' },
    { label: 'Não Publicado', value: 'naoPublicado' },
    { label: 'Agendado', value: 'agendado' }
  ];
  selectedStreamStatus: string | null = null; // Armazena o status do stream selecionado
  streamStatusOptions = [
    { label: 'Todos', value: null },
    { label: 'Ativo', value: 'idle' },
    { label: 'Desabilitado', value: 'disabled' },
    { label: 'Ao vivo', value: 'active' }
  ];

  onStreamStatusSelect() {
    this.applyFilters();
  }
  onStatusSelect() {
    this.applyFilters();
  }
  onFilterSlicks(event: Event) {
    this.filterValue = (event.target as HTMLInputElement).value.toLowerCase();
    this.applyFilters(); // Atualiza os filtros.
  }

  onDateSelect() {
    this.applyFilters();
  }
  onTypeSelect() {
    this.applyFilters();
  }
  date_from!: string | null;
  date_to!: string | null;
  applyFilters() {
    const startDate = this.rangeDates && this.rangeDates[0] ? this.rangeDates[0].getTime() : null;
    const endDate = this.rangeDates && this.rangeDates[1] ? this.rangeDates[1].getTime() : null;

    if (startDate && endDate && this.rangeDates && this.rangeDates[0] && this.rangeDates[1]) {
      // Faz a chamada ao serviço com as datas formatadas
      this.date_from = this.formatDateToDDMMYYYY(this.rangeDates[0]);
      this.date_to = this.formatDateToDDMMYYYY(this.rangeDates[1]);
      this.fetchFilteredData(startDate, endDate);
      
      this.sendUidsToService([], 0);

    } else {
      // Se o intervalo de datas não estiver completo, aplica os outros filtros localmente
      this.filterDataLocally();
    }
  }

  formatDateToDDMMYYYY(date: Date): string {
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Janeiro é 0!
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  }

  fetchFilteredData(startDateTimestamp: number, endDateTimestamp: number) {
    // Converte timestamps para objetos Date
    const startDate = new Date(startDateTimestamp);
    const endDate = new Date(endDateTimestamp);

    // Formata as datas
    const formattedStartDate = this.formatDateToDDMMYYYY(startDate);
    const formattedEndDate = this.formatDateToDDMMYYYY(endDate);

    // Utiliza as datas formatadas na chamada ao serviço
    this.liveShopService.getFilteredAssetsByDate(formattedStartDate, formattedEndDate).subscribe({
      next: (res) => {
       // this.assets = res; // Dados filtrados por datas
        this.filteredAssets = [...this.assets]; // Inicia com dados filtrados por datas
        this.reapplyLocalFilters(); // Nova função para reaplicar filtros locais
      },
      error: (err) => {
        console.error('Erro ao buscar dados filtrados', err);
      }
    });
  }
  reapplyLocalFilters() {
    let totalDuration = 0; // Reseta totalDuration

    // Filtra novamente os assets com base nos filtros locais
    this.filteredAssets = this.filteredAssets.filter(asset => {
      return asset.items.filter(item => {
        // Aplica filtragem por tipo
        const type = item.media.type;
        const typeFilter =
          this.selectedType === 'live' ? (type === null || type.toLowerCase().includes('live')) :
            this.selectedType === 'shorts' ? (type !== null && type.toLowerCase() === 'shorts') : true;

        // Aplica filtragem por status do stream
        const streamStatus = item.media.stream_status;
        const streamStatusFilter =
          this.selectedStreamStatus === 'idle' ? streamStatus === 'idle' :
            this.selectedStreamStatus === 'disabled' ? (streamStatus === 'Disabled' || streamStatus === null) :
              this.selectedStreamStatus === 'active' ? streamStatus === 'Active' : true;

        // Aplica filtragem por status de publicação
        const statusFilter =
          this.selectedStatus === 'publicado' ? item.media.status === 1 :
            this.selectedStatus === 'naoPublicado' ? item.media.status === 0 :
              this.selectedStatus === 'agendado' ? (item.media.status === 0) : true;

        // Aplica filtragem por nome
        const nameFilter = item.content.title.toLowerCase().includes(this.filterValue);

        // Verifica se o item passa por todos os critérios de filtro
        const isItemFiltered = typeFilter && streamStatusFilter && statusFilter && nameFilter;

        // Acumula a duração apenas para itens que passam pelo filtro
        if (isItemFiltered && item.media.duration) {
          totalDuration += item.media.duration;
        }

        return isItemFiltered;
      }).length > 0; // Garante que o asset seja incluído se algum item passar pelo filtro
    });

    // Atualiza o tempo total assistido formatado após filtragem
    this.contentTime = this.formatDuration(totalDuration);
  }


  filterDataLocally() {
    let totalDuration = 0; // Reseta totalDuration para cada aplicação do filtro

    // Aplica os filtros localmente, exceto por datas
    this.filteredAssets = this.assets.filter(asset => {
      return asset.items.filter(item => {
        // Aplica filtragem por tipo
        const type = item.media.type;
        const typeFilter =
          this.selectedType === 'live' ? (type === null || type.toLowerCase().includes('live')) :
            this.selectedType === 'shorts' ? (type !== null && type.toLowerCase() === 'shorts') : true;

        // Aplica filtragem por status do stream
        const streamStatus = item.media.stream_status;
        const streamStatusFilter =
          this.selectedStreamStatus === 'idle' ? streamStatus === 'idle' :
            this.selectedStreamStatus === 'disabled' ? (streamStatus === 'Disabled' || streamStatus === null) :
              this.selectedStreamStatus === 'active' ? streamStatus === 'Active' : true;

        // Aplica filtragem por status de publicação
        const statusFilter =
          this.selectedStatus === 'publicado' ? item.media.status === 1 :
            this.selectedStatus === 'naoPublicado' ? item.media.status === 0 :
              this.selectedStatus === 'agendado' ? (item.media.status === 0) : true; // Agendado baseado em outro critério, se necessário

        // Aplica filtragem por nome
        const nameFilter = item.content.title.toLowerCase().includes(this.filterValue);

        // Verifica se o item passa por todos os critérios de filtro
        const isItemFiltered = typeFilter && streamStatusFilter && statusFilter && nameFilter;

        // Acumula a duração apenas para itens que passam pelo filtro
        if (isItemFiltered && item.media.duration) {
          totalDuration += item.media.duration;
        }

        return isItemFiltered;
      }).length > 0; // Garante que o asset seja incluído se algum item passar pelo filtro
    });

    // Atualiza o tempo total assistido formatado após filtragem
    this.contentTime = this.formatDuration(totalDuration);

    // Chama collectAndSendUids se necessário após a filtragem local
    this.collectAndSendUids();
  }

  calculateTotalDuration() {
    let totalDuration = 0;
    // Lógica para calcular totalDuration...
    this.contentTime = this.formatDuration(totalDuration);
  }

  formatDuration(totalSeconds: number): string {
    // Converte total de segundos para minutos
    const totalMinutes = Math.floor(totalSeconds / 60);
    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;

    return `${hours}h${minutes.toString().padStart(2, '0')}m`;
  }


  countLikes: number = 0;
  countEspectadores: number = 0;
  timeWatched: number = 0;
  contentTime: string | null = "0h0m";


  countLikes2: number = 0;
  countEspectadores2: number = 0;
  timeWatched2: number = 0;
  contentTime2: string | null = "0h0m";

  percentageLikes: number = 0;
  percentageEspectadores: number = 0;
  percentageWatched: number = 0;
  percentageTime: number = 0;

  collectAndSendUids() {
    const uids = this.filteredAssets.flatMap(asset =>
      asset.items.map(item => item.content.uid)
    );

    // Agora, uids é um array de todos os UIDs dos items filtrados
    //console.log(uids)
    this.sendUidsToService(uids, 1);
  }
  sendUidsToService(uids: string[], n: number) {
    this.loading = true;

    if (this.date_from != null && this.date_to != null) {
      // Substitua com a chamada ao seu serviço
      console.log('entrou na chamada com datas setadas')
      // this.liveShopService.sendUids([], 0, this.date_from, this.date_to).subscribe({
      //   next: (res) => {

      //     console.log(res.likeCount);
      //     this.countLikes = res.likeCount;
      //     this.countEspectadores = res.espctadores;
      //     this.timeWatched = (res.watched * 100);
      //     this.contentTime = this.formatDuration(res.content);
      //     let contentTimeTmp = res.content;

      //     //this.loading = false;
      //     if (this.date_from != null && this.date_to != null) {
      //       let dateFrom = this.convertStringToDate(this.date_from);
      //       let dateTo = this.convertStringToDate(this.date_to);

      //       // Subtrai 30 dias
      //       dateFrom.setDate(dateFrom.getDate() - 30);
      //       dateTo.setDate(dateTo.getDate() - 30);

      //       let newDateFrom = this.formatDateToDDMMYYYY(dateFrom);
      //       let newDateTo = this.formatDateToDDMMYYYY(dateTo);

      //       //this.date_from = this.formatDateToDDMMYYYY(dateFrom);
      //       //this.date_to = this.formatDateToDDMMYYYY(dateTo);
      //       ///////////////////////////////////////////////////////////
      //       this.liveShopService.sendUids([], 0, newDateFrom, this.date_from).subscribe({
      //         next: (res) => {

      //           console.log(res.likeCount);
      //           this.countLikes2 = res.likeCount;
      //           this.countEspectadores2 = res.espectadores;
      //           this.timeWatched2 = (res.watched * 100);
      //           this.contentTime2 = this.formatDuration(res.content);

                

      //           this.percentageLikes = this.calculatePercentageDifference(this.countLikes, this.countLikes2);
      //           this.percentageEspectadores = this.calculatePercentageDifference(this.countEspectadores, this.countEspectadores2);
      //           this.percentageWatched = this.calculatePercentageDifference(this.timeWatched, this.timeWatched2);
      //           this.percentageTime = this.calculatePercentageDifference(contentTimeTmp, res.content);
      //           this.loading = false;
      //         },
      //         error: (err) => {
      //           this.loading = false;
      //         }
      //       });
      //       ///////////////////////////////////////////////////////////
      //     }


      //   },
      //   error: (err) => {
      //     this.loading = false;
      //   }
      // });
    } else {
      // Substitua com a chamada ao seu serviço
      this.liveShopService.sendUids(uids, n).subscribe({
        next: (res) => {

          console.log(res.likeCount);
          this.countLikes = res.likeCount;
          this.countEspectadores = res.espectadores;
          this.timeWatched = (res.watched * 100);
          this.contentTime = this.formatDuration(res.content);

          this.loading = false;
        },
        error: (err: any) => { 
          console.log('err', err);
          this.loading = false;
        }
      });
    }
  }
  calculatePercentageDifference(first: number, second: number): number {
    if (first === 0) {
      return second !== 0 ? 100 : 0; // Ajuste conforme a necessidade para casos onde o primeiro valor é 0
    }
    return ((first - second) / first) * 100;
  }
  convertStringToDate(dateStr: string): Date {
    const [day, month, year] = dateStr.split('/').map(num => parseInt(num, 10));
    return new Date(year, month - 1, day);
  }
  searchTerm: string = '';
  clearFilter(){
    this.rangeDates = null;
    this.selectedStatus = 'todos';
    this.selectedStreamStatus = null;
    this.selectedType = null;
    this.searchTerm = '';
    

  }
}
